import { addOfficeDivision } from "../../../../../actions/Utilities/OfficeDivision";
import { useMutation } from "react-query";

const useAddOfficeDivision = () => {
  return useMutation(addOfficeDivision);
};
export default useAddOfficeDivision;
